// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Form,
  Grid,
} from 'semantic-grab-ui/src';
import type { RequestStates } from 'types/redux';
import { isRequestsPending, hasJustSuccess } from 'utils/request-state-utils';
import Toastr from 'utils/toastr-util';
import languages from 'data/languages.json';
import { sendPreviewMessage } from 'actions/newTridentExtra';

type Props = {
  templateID: string,
  params: Object,
  userType: string,
  sendPreviewMessage: Function,
  sendMessageRequest: RequestStates,
};

const autoLanguageSelection = 'auto';

// SendPreviewMessageForm is a form for sending preview(aka. test) hedwig message
class SendPreviewMessageForm extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      accountID: '',
      language: autoLanguageSelection,
      sending: false, // this is to prevent handling request state change of other component instances
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (hasJustSuccess(this.props.sendMessageRequest, nextProps.sendMessageRequest) && this.state.sending) {
      Toastr.success('Test message is successfully sent!');
    }
    if (!isRequestsPending(nextProps.sendMessageRequest)) {
      this.setState({ sending: false });
    }
  }

  handleInputChange = (_, data: any) => {
    const { name, value } = data;
    this.setState({
      [name]: value,
    });
  };

  getTransformedParams = (params: Object) => {
    const transformed = {};
    _.map(params, (val, key) => {
      _.set(transformed, key, {
        params: val,
      });
    });
    return transformed;
  };

  sendMessage = () => {
    const { accountID, language } = this.state;
    const { userType, templateID, params } = this.props;
    // account ID should not be empty
    if (_.isEmpty(accountID)) {
      alert(`Please specify ${userType} ID`);
      return;
    }

    this.setState({
      sending: true,
    });

    // prepare parameters depending on language selection
    let template;
    if (language === autoLanguageSelection) {
      template = {
        id: templateID,
        enableLangDetection: true,
        langPayload: this.getTransformedParams(params),
      };
    } else {
      template = {
        id: templateID,
        language,
        params: _.get(params, language, {}),
      };
    }
    this.props.sendPreviewMessage({
      recipientID: accountID,
      recipientType: userType,
      template,
    });
  };

  render() {
    const selectedLangs = _.keys(this.props.params);
    const languageOptions = _.map(selectedLangs, lang => {
      return {
        key: lang,
        value: lang,
        text: _.get(languages, `${lang}.label`, lang),
      };
    });
    languageOptions.push({
      key: autoLanguageSelection,
      value: autoLanguageSelection,
      text: 'Auto Select',
    });

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={5}>
            <Form.Input
              required
              name="accountID"
              label={`${this.props.userType} ID`}
              value={_.get(this.state, 'accountID')}
              onChange={this.handleInputChange}
            />
          </Grid.Column>
          <Grid.Column width={5}>
            <Form.Select
              required
              name="language"
              label="language"
              options={languageOptions}
              value={_.get(this.state, 'language')}
              onChange={this.handleInputChange}
            />
          </Grid.Column>

          <Grid.Column width={4}>
            <Form.Button
              positive
              onClick={this.sendMessage}
              loading={isRequestsPending(this.props.sendMessageRequest)}
              style={{ marginTop: '25px' }}
            >
              Send
            </Form.Button>
          </Grid.Column>

        </Grid.Row>
      </Grid>
    );
  }
}

function mapStateToProps(state: StoreState) {
  return {
    sendMessageRequest: _.get(state.requests, 'sendPreviewMessageRequest', {}),
  };
}

export default connect(mapStateToProps, {
  sendPreviewMessage,
})(SendPreviewMessageForm);
